import { userService } from '../services/user.service';
import { logout } from '../auth';

const resetApiMiddleware = (store) => (next) => (action) => {
  if (action.type === logout.type) {
    store.dispatch(userService.util.resetApiState());
  }
  return next(action);
};

export default resetApiMiddleware;
